import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryParamProvider } from "use-query-params";
import { ReachAdapter } from "use-query-params/adapters/reach";
import { App } from "./containers/App";
import store from "./store";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { Router } from "@reach/router";
import { defaultTheme } from "./theme/material";
import { Route } from "components/route";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  // @ts-expect-error - @reach/router has type compatibility issues with React 18
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={defaultTheme}>
        <QueryParamProvider adapter={ReachAdapter}>
          {/* @ts-expect-error - @reach/router Router component type issue */}
          <Router primary={false}>
            {/* @ts-expect-error - @reach/router Route component type issue */}
            <Route default component={App} />
          </Router>
        </QueryParamProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
);
